import wmain from "../../../assets/docs/whatsapp/wmain.png";
import wsubmain from "../../../assets/docs/whatsapp/wsubmain.png";
import wsuccess from "../../../assets/docs/whatsapp/wsuccess.png";
import wreview from "../../../assets/docs/whatsapp/wreview.png";
import wper from "../../../assets/docs/whatsapp/wper.png";
import wpageselect from "../../../assets/docs/whatsapp/wpageselect.png";
import wcreatewbapa from "../../../assets/docs/whatsapp/wcreatewbapa.png";
import wcreatepage from "../../../assets/docs/whatsapp/wcreatepage.png";
import addNo from "../../../assets/docs/whatsapp/addNo.png";
import wfinish from "../../../assets/docs/whatsapp/wfinish.png";
import wwdashboard from "../../../assets/docs/whatsapp/wwdashboard.png";

const jaanoWhatsappIntegration = {
  platform: "WhatsApp",
  chatbot: "Jaano.ai",
  desc: "Integrating WhatsApp with Jaano.ai allows your custom chatbot to communicate directly with customers via WhatsApp, providing a seamless and efficient way to handle inquiries and automate responses. This guide will walk you through the necessary steps to connect your chatbot to a WhatsApp phone number, ensuring smooth and effective customer interactions.",
  warning:
    "The WhatsApp phone number integrated with Jaano.ai can only be used by the chatbot, not in the WhatsApp or WhatsApp Business app.",
  prerequisites: [
    {
      title: "Delete WhatsApp Account (if number is already in use)",
      steps: [
        "Open WhatsApp or WhatsApp Business app.",
        "Go to Settings → Account.",
        "Select 'Delete my account'.",
        "Wait a few minutes until the number is released.",
      ],
    },
    {
      title: "Disable Two-Step Verification (Meta Business users only)",
      steps: [
        "Log in to your WhatsApp Business account via Meta Developer.",
        "Select the phone number to integrate.",
        "Navigate to Settings → Two-step verification.",
        "Click 'Turn off two-step verification'.",
      ],
    },
    {
      title: "Ensure Approved Display Name",
      note: "Meta requires an approved display name for WhatsApp API. [Learn more](https://www.facebook.com/business/help/1126628985118185)",
    },
  ],
  steps: [
    {
      title: "Step 1: Select Your Jaano.ai Bot",
      instructions: [
        "Log into your Jaano.ai dashboard.",
        "Navigate to Dashboard → [Your Bot] → Connect → Integrations.",
        "Click 'Connect' on the WhatsApp integration card.",
      ],
      images: [wmain],
    },
    {
      title: "Step 2: Authenticate via Facebook",
      instructions: [
        "Log in using your personal Facebook account.",
        "Click 'Get Started' when prompted.",
      ],
      images: [wsubmain, wper],
    },
    {
      title: "Step 3: Configure Your Business Profile",
      instructions: [
        "Choose an existing business or create a new one.",
        "Fill in the required business profile information.",
        "Add a phone number (recommended: only one number per profile).",
        "Click 'Continue' and wait for verification.",
        "Click 'Finish' once verification is complete.",
      ],
      images: [
        wpageselect,
        wcreatewbapa,
        wcreatepage,
        addNo,
        wreview,
        wfinish,
        wsuccess,
      ],
    },
    {
      title: "Step 4 (Optional): Customize or Manage",
      instructions: [
        "Click the 'ℹ' (info) icon next to WhatsApp in the integration list to manage settings.",
        "To customize message styling or remove the phone number, use the 'Manage WhatsApp' page.",
        "To update your bot’s WhatsApp profile settings, go to 'Profile' and click 'Save'.",
      ],
      images: [wwdashboard],
    },
    {
      title: "🎉 Integration Complete",
      instructions: [
        "Your Jaano.ai bot is now connected to WhatsApp!",
        "You can now receive and respond to messages sent to your WhatsApp number using your chatbot.",
      ],
    },
  ],
  metaUsage: {
    note: "You can send 1000 free messages monthly using WhatsApp Cloud API.",
    tip: "Add a payment method under Meta → Billing Settings to exceed this limit.",
  },
  congratulations:
    "🎉 Congratulations! Your Jaano.ai chatbot is now live on WhatsApp and ready to handle conversations.",
};

export default jaanoWhatsappIntegration;
